import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import GtrSuper from '@/modules/common/components/mixins/gtr-super.mixin'
import Container from 'typedi'
import ErrorHandlerService from '@/modules/common/services/error-handler.service'
import { AllMedia, Media, MediaStoreUploadResult } from '@/interfaces'

@Component({
  name: 'GtrFilePicker',
  computed: {
    ...mapState('media', ['media', 'allMediaUploadsProcessed'])
  }
})
export default class GtrFilePicker extends GtrSuper {
  // Mime types to display and allowed for file upload component.
  @Prop({ required: false, type: String, default: '' })
  mimeTypes!: string

  @Prop({ required: false, type: String, default: '' })
  value!: string

  @Prop({ required: false, type: String, default: '' })
  classProp!: string

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: false

  @Prop({ required: false, type: String, default: '' })
  fieldLabel!: string

  media!: AllMedia
  allMediaUploadsProcessed!: boolean

  data () {
    return {
      loading: false,
      filePickerOpen: false,
      selectedMedia: null,
      urlToSelect: null,
      mediaToDelete: null
    }
  }

  @Watch('allMediaUploadsProcessed')
  async onAllMediaUploadsProcessedChange (allMediaUploadsProcessed: boolean) {
    if (allMediaUploadsProcessed) {
      await this.fetchMedia()
      this.setSelectedMediaByUrl(this.$data.urlToSelect)
    }
  }

  async fetchMedia () {
    try {
      this.$data.loading = true
      await this.$store.dispatch('media/getMedia', { event_uuid: this.$route.params.event_uuid })
    } catch (error) {
      Container.get(ErrorHandlerService).error(error)
    } finally {
      this.$data.loading = false
      this.$store.dispatch('common/hideLoader')
    }
  }

  get visibleMedia (): Media[] {
    return this.media?.Active?.filter(file => file.mime_type && this.mimeTypes.includes(file.mime_type)) ?? []
  }

  get selectedMediaUrl (): string {
    return this.$data.selectedMedia?.url ?? ''
  }

  get selectedMediaName (): string {
    return this.$data.selectedMedia?.name ?? ''
  }

  set selectedMediaName (name: string) {
    if (this.$data.selectedMedia) {
      this.$data.selectedMedia.name = name
    }
  }

  setSelectedMediaByUrl (payload: string) {
    this.$data.selectedMedia = this.media?.Active?.find((media: Media) => media.url === payload)
  }

  async onFileUploadChange (files: File[]) {
    this.$data.loading = true
    const uploads: MediaStoreUploadResult[] = await this.$store.dispatch('media/uploadMedia', { event_uuid: this.$route.params.event_uuid, files })
    if (uploads.length) {
      this.$data.urlToSelect = uploads[uploads.length - 1]?.url
    }
    this.$data.loading = false
  }

  handleSelectMedia (media: Media) {
    this.$data.selectedMedia = media
  }

  private async handleOpenFilePicker () {
    this.$store.dispatch('common/showLoader', { value: true })
    await this.fetchMedia()
    if (this.value) {
      this.setSelectedMediaByUrl(this.value)
    }
    this.$data.filePickerOpen = true
  }

  private handleCancel () {
    this.$data.selectedMedia = null
    this.$data.filePickerOpen = false
  }

  private handleClear () {
    this.$data.selectedMedia = null
    this.$emit('change', this.selectedMediaUrl)
  }

  private handleOk () {
    this.$data.filePickerOpen = false
    this.$emit('input', this.selectedMediaUrl)
  }
}
